import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=359813e2&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=359813e2&prod&scoped=true&lang=css"
import style1 from "./Registration.vue?vue&type=style&index=1&id=359813e2&prod&lang=less&scoped=true"
import style2 from "./Registration.vue?vue&type=style&index=2&id=359813e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359813e2",
  null
  
)

export default component.exports